//ximport { withRouter } from 'react-router-dom';
import React, { useState, useEffect }  from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents, LayersControl,LayerGroup} from 'react-leaflet';
import { IonLoading, IonToast, useIonViewWillEnter, IonCol, IonImg, IonButton} from '@ionic/react';


//import markerIconPng from "leaflet/dist/images/marker-icon.png";
import {Icon} from 'leaflet';
import { get } from '../../services/storage.service';
//Camera Plugin
import { usePhotoGallery } from '../../hooks/usePhotoGallery';
import { Geolocation, Geoposition } from '@ionic-native/geolocation';

//get geolocation for initial placement
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';
import './map-group.css';

  //colored icons
  const blueIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  }),
  greenIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|2ecc71&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  }),
  orangeIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FF9400&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  });

interface LocationError {
    showError: boolean;
    message?: string;
}

export const MapGroup = (
    props: {
        listOfMarkers: any;
        listOfMarkers2: any;
        listOfMarkers3: any;
        mapCenter: any;
        loadMarkers: any;
        updateMarkers: any;
        setMapCenter: any;
        color1:any;
        color2:any;
        color3:any;
    }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<LocationError>({ showError: false });
    const [getposition, setPosition] = useState<Geoposition>();

    const [title, setTitle] = useState<string>("New Exploration");
    const [description, setDescripton] = useState<string>("popup description");
    const [getMapCenter, setMapCenter] = useState<any>();
    const [locationchange,setNewLocation] = useState<boolean>(false);

 
    const [getMapLng, setMapLng] = useState<any>(-89.401230);//these should be set dynamically to the center of the map. 
    const [getMapLat, setMapLat] = useState<any>(43.073051);

    const [longitude, setLong] = useState<number>(-89.401230);
    const [latitude, setLat] = useState<number>(43.073051);

    const [selectField, setSelected]= useState<any>("Select a Marker");
    const [selectText, setTextSelected]= useState<any>("Type a Description");
    const [selectMarker, setMarkerID]= useState<any>(0);

    const {photos, takePhoto} = usePhotoGallery();
    
    const [icon, setIcon] = useState(blueIcon);

    const [icon1, setIcon1] = useState(blueIcon);
    const [icon2, setIcon2] = useState(blueIcon);
    const [icon3, setIcon3] = useState(blueIcon);

    const [title1, setTitle1] = useState('N%87jh');
    const [title2, setTitle2] = useState('N%87jh');
    const [title3, setTitle3] = useState('N%87jh');

    const [fileName, setFileName] = useState<any>();
    const [webviewName, setWebviewName] = useState<any>();

    console.log(props.mapCenter);
        console.log(props.listOfMarkers.length);
        console.log(props.listOfMarkers);
        //console.log("markerTotal",props.markertotal);
;    const latlng = "";
    const center = [51.505, -0.09];
    const loadLocation = () => {
        setLong(longitude);
        setLat(latitude);
        setNewLocation(true);
        setLoading(false);
    }
    const getLocation = async () => {
        setNewLocation(true);
        setLoading(true);
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        try {
            const getposition = await Geolocation.getCurrentPosition(options);
            setPosition(getposition);
            setLong(getposition.coords.longitude);
            setLoading(false);
            setNewLocation(false);
            setError({ showError: false });
            props.setMapCenter(getposition.coords.latitude,getposition.coords.longitude);
            console.log(props.mapCenter,getposition.coords.latitude,getposition.coords.longitude);
            setMapLat(getposition.coords.latitude);
            setMapLng(getposition.coords.longitude);
        } catch (e) {
            setError({ showError: true, message: e.message });
            setLoading(false);
        }
    }
    //get the titles
    get("project1")
    .then(function (finalResult) { //get the user data to authenticate the user
       const userD = JSON.parse(finalResult);
       if(finalResult !== null){
         setTitle1(userD.Title);
       }
    }).catch(err => {//unable to load the local storage
        console.log("e: " + err.message);
    });
    get("project2")
    .then(function (finalResult) { //get the user data to authenticate the user
       const userD = JSON.parse(finalResult);
       if(finalResult !== null){
         setTitle2(userD.Title);
       }
    }).catch(err => {//unable to load the local storage
        console.log("e: " + err.message);
    });
    get("project3")
    .then(function (finalResult) { //get the user data to authenticate the user
       const userD = JSON.parse(finalResult);
       if(finalResult !== null){
         setTitle3(userD.Title);
       }
    }).catch(err => {//unable to load the local storage
        console.log("e: " + err.message);
    });

    function MyComponent(e:any) {
        const map = useMap();
        map.flyTo(props.mapCenter);
        map.invalidateSize();
        const latlng = map.getCenter();
        //load Marker
        var color1 = props.color1;
        if(color1 === "green"){setIcon1(greenIcon);
        }else if(color1 === "blue"){setIcon1(blueIcon);
        }else if(color1 === "orange"){setIcon1(orangeIcon);
        }
        var color2 = props.color2;
        if(color2 === "green"){setIcon2(greenIcon);
        }else if(color2 === "blue"){setIcon2(blueIcon);
        }else if(color2 === "orange"){setIcon2(orangeIcon);
        }
        var color3 = props.color3;
        if(color3 === "green"){setIcon3(greenIcon);
        }else if(color3 === "blue"){setIcon3(blueIcon);
        }else if(color3 === "orange"){setIcon3(orangeIcon);
        }
        return null;
    }
    function LocationMarker() {
       const map = useMapEvents({
            click(e) {
                setMapLat(e.latlng.lat);
                setMapLng(e.latlng.lng);
                props.setMapCenter(e.latlng.lat,e.latlng.lng);
            }
          })
       return null;
    }

    function updateMarkers(x:any,field:any){
        props.listOfMarkers[x]['title'] = field;
    }
    function setSelectedImage(x:any,y:any,z:any){
        console.log("z",z);

        photos.length = 0;
        var v;
        if(x){
            //clear out current photos
            for(v=0;v<z.length;v++){
                photos.push(z[v]);
            }
            photos.push(z[0]);
            console.log(photos);
        }
        console.log(props.listOfMarkers);
    }

    //onload
    useIonViewWillEnter(() => {
        console.log('ionViewDidEnter event fired');
        loadLocation();
    });
    useEffect(() => {
        console.log(photos);
        console.log(selectMarker);
      }, [photos]);
    
  return (
        <>
        <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Getting Location...'}
      />
      <IonToast
          isOpen={error.showError}
          onDidDismiss={() => setError({ message: "", showError: false })}
          message={error.message}
          duration={9000}
      />
      <IonCol size="12" size-sm="12">
              
        <MapContainer 
        className="map-group" 
        center={props.mapCenter}
        tap={false}
        zoom={13} 
        scrollWheelZoom={false}
        >
            
            <MyComponent 
            center={props.mapCenter}
            tap={false}
            zoom={13} />
            <LocationMarker/>
            <TileLayer 
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
           <LayersControl position="topright">
           {(function() {
                if(title1 !== 'N%87jh'){
                    return(
                        <>
                        <LayersControl.Overlay checked name={title1}>
                        <LayerGroup>
                            { props.listOfMarkers.map(
                                (
                                    mark: {
                                        pos: any;
                                        title: { rendered: string };
                                        description: {rendered: string};
                                        id: any;
                                        fileid: any;
                                        webid: any;
                                        gallery: any;
                                        color: any;

                                    },
                                    index: string | number | null | undefined
                                    
                                ) => (
                                    
                                        <Marker
                                            key={index}
                                            draggable={false}
                                            position={mark.pos} 
                                            icon={icon1}
                                            
                                            eventHandlers={{
                                                click: (e) => {
                                                console.log(index);
                                                console.log(e);
                                                setSelected(mark.title);//set the title
                                                setTextSelected(mark.description);//set the description
                                                setMarkerID(mark.id);
                                                setFileName(mark.fileid);
                                                setWebviewName(mark.webid);
                                                setSelectedImage(mark.fileid,mark.webid,mark.gallery);
                                                console.log(mark.pos);
                                                },
                                                
                                            }}>
                                            <Popup minWidth={90}>
                                                        {(function() {
                                                        if(mark.webid){
                                                            return(
                                                                <>
                                                                <IonImg src={mark.webid} className="small-image"/>
                                                                </>
                                                            )

                                                        }
                                                    })()}
                                                <strong>{selectField}</strong>
                                                <p>{selectText}</p>
                                            </Popup>
                                        </Marker>
                                )
                            )} 
                            </LayerGroup>
                            </LayersControl.Overlay>
                            </>
                    )
            }
            })()}
            {(function() {
                if(title2 !== 'N%87jh'){
                    return(
                        <>
                        <LayersControl.Overlay checked name={title2}>
                        <LayerGroup>
                        { props.listOfMarkers2.map(
                            (
                                mark: {
                                    pos: any;
                                    title: { rendered: string };
                                    description: {rendered: string};
                                    id: any;
                                    fileid: any;
                                    webid: any;
                                    gallery: any;
                                    color: any;

                                },
                                index: string | number | null | undefined
                                
                            ) => (
                                    <>
                                    <Marker 
                                        key={index}
                                        draggable={false}
                                        position={mark.pos} 
                                        icon={icon2}
                                        
                                        eventHandlers={{
                                            click: (e) => {
                                            console.log(index);
                                            console.log(e);
                                            setSelected(mark.title);//set the title
                                            setTextSelected(mark.description);//set the description
                                            setMarkerID(mark.id);
                                            setFileName(mark.fileid);
                                            setWebviewName(mark.webid);
                                            setSelectedImage(mark.fileid,mark.webid,mark.gallery);
                                            console.log(mark.pos);
                                            },
                                            
                                        }}>
                                        <Popup minWidth={90}>
                                                    {(function() {
                                                    if(mark.webid){
                                                        return(
                                                            <>
                                                            <IonImg src={mark.webid} className="small-image"/>
                                                            </>
                                                        )

                                                    }
                                                })()}
                                            <strong>{selectField}</strong>
                                            <p>{selectText}</p>
                                        
                                        </Popup>
                                    </Marker>
                                    </>
                    )
                )} 
                </LayerGroup>
                </LayersControl.Overlay>
                </>
                    )
            }
            })()}
            {(function() {
                if(title3 !== 'N%87jh'){
                    return(
                        <>
                        <LayersControl.Overlay checked name={title3}>
                        <LayerGroup>

                        { props.listOfMarkers3.map(
                            (
                                mark: {
                                    pos: any;
                                    title: { rendered: string };
                                    description: {rendered: string};
                                    id: any;
                                    fileid: any;
                                    webid: any;
                                    gallery: any;
                                    color: any;

                                },
                                index: string | number | null | undefined
                                
                            ) => (
                                    <>
                                    
                                    <Marker 
                                        key={index}
                                        draggable={false}
                                        position={mark.pos} 
                                        icon={icon3}
                                        
                                        eventHandlers={{
                                            click: (e) => {
                                            console.log(index);
                                            console.log(e);
                                            setSelected(mark.title);//set the title
                                            setTextSelected(mark.description);//set the description
                                            setMarkerID(mark.id);
                                            setFileName(mark.fileid);
                                            setWebviewName(mark.webid);
                                            setSelectedImage(mark.fileid,mark.webid,mark.gallery);
                                            console.log(mark.pos);
                                            },
                                            
                                        }}>
                                        <Popup minWidth={90}>
                                                    {(function() {
                                                    if(mark.webid){
                                                        return(
                                                            <>
                                                            <IonImg src={mark.webid} className="small-image"/>
                                                            </>
                                                        )

                                                    }
                                                })()}
                                            <strong>{selectField}</strong>
                                            <p>{selectText}</p>
                                        
                                        </Popup>
                                    </Marker>
                                
                                    </>
                            )
                        )} 
                        </LayerGroup>
                        </LayersControl.Overlay>
                        </>
                    )
            }
            })()}
        <LayersControl.BaseLayer checked name="OpenStreetMap"
            ><TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                
                /></LayersControl.BaseLayer><LayersControl.BaseLayer name="Satellite Maps"><TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">Mapbox</a> contributors'
                url="https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoidm9pbGFqb2huIiwiYSI6ImNrbWNjd3l6MDJhdjIydnFyZGRycTY5NDEifQ.POLhCsOl3z_p9LGn-36VnA"
                /></LayersControl.BaseLayer>
        </LayersControl>

    </MapContainer>
    <IonButton color="primary" onClick={getLocation}>{"Get My Location"}</IonButton>
    </IonCol>
    </>
  );
};
